import type React from 'react'
import { createContext, useContext } from 'react'

export type LocaleContextProps = {
  locale: string
  setLocale: React.Dispatch<React.SetStateAction<string>>
}

const LocaleContext = createContext<LocaleContextProps>({
  locale: 'en-US',
  setLocale: () => 'en-US',
})

export const useLocale = (): LocaleContextProps => {
  return useContext(LocaleContext)
}

export default LocaleContext
